import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectorRef, OnInit, OnDestroy } from '@angular/core';
import { FormControl, FormGroupDirective, } from '@angular/forms';
import { maxBytesError, inValidDateError } from '../../../shared/validators';
import { IMyDpOptions, IMyDateModel, } from 'mydatepicker';
import { Subscription } from 'rxjs';

@Component({
    selector: 'shipment-form-field',
    template: require('./form-field.component.html'),
    styles: [require('./form-field.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShipmentFormFieldComponent implements OnInit, OnChanges, OnDestroy {

    @Input()
    public controlName: string;

    @Input()
    public fieldControl: FormControl;

    @Input()
    public isSubField = false;

    @Input()
    public groupName: string;

    @Input()
    public sequence: number;

    @Input()
    public label: string;

    @Input()
    public placeholder: string;

    @Input()
    public dropDownList: { key: string, value: string }[];

    @Input()
    public isDropDownField = false;

    @Input()
    public fieldType = 'text';

    @Input()
    public isRequired: boolean;

    @Input()
    public showInput = true;

    @Input()
    public errorMsg = '';

    @Input()
    public alignDate = false;

    @Input()
    public customErrorMsg = '';

    @Input()
    public minValueLength = 3;

    @Input()
    public showLoading = false;

    @Input()
    public isPhoneNumber = false;

    @Input()
    public isDateField: boolean;

    @Input()
    public displayError: boolean;

    @Input()
    public showDropDownSearch = false;

    @Input()
    public disclaimerText = '';

    @Output()
    public onDropDownValueSelected: EventEmitter<any> = new EventEmitter();

    @Output()
    public onScheduledDateEntered: EventEmitter<any> = new EventEmitter();

    @Output()
    public onInvalidSchedulesDateEntered: EventEmitter<boolean> = new EventEmitter();

    @Output()
    public onValueEntered: EventEmitter<string> = new EventEmitter();

    @Output()
    public onRadioButtonValueChanged: EventEmitter<boolean> = new EventEmitter();

    public showDropDown = false;
    public isInputFocused = false;
    public subscription: Subscription;
    public filterItems: { key: string, value: string }[] = [];

    public myDatePickerOptions: IMyDpOptions = {
        dateFormat: 'dd-mmm-yyyy',
        showSelectorArrow: false,
        showTodayBtn: true,
        todayBtnTxt: 'Today'
    };

    constructor(private formGroupDirective: FormGroupDirective, private changedect: ChangeDetectorRef) {
        
    }

    public ngOnInit() {
        this.subscription = this.fieldControl.valueChanges.subscribe(value => {
            this.changedect.markForCheck();
        });
        this.filterItems = this.dropDownList;
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes && changes.dropDownList && this.isDropDownField) {
            this.filterItems = this.dropDownList;
        }
    }

    public ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    public dropDownItemClicked(item: any) {
        this.filterItems.forEach(t => {
            if (t.key === item.key) {
                item.selected = true;
            }
        });
        this.fieldControl.setValue(item.value);
        this.showDropDown = false;
        this.onDropDownValueSelected.emit(item);
    }

    public onScheduledChange($event: IMyDateModel) {
        this.fieldControl.setValue($event.formatted);
        this.onScheduledDateEntered.emit($event.formatted);
    }

    public IsInvalidField() {
        if (this.fieldControl.touched || this.fieldControl.value || this.displayError) {
            if (this.isPhoneNumber && (this.fieldControl.hasError('pattern') || this.fieldControl.hasError(maxBytesError))) {
                this.customErrorMsg = 'Please enter valid Phone Number.';
                return true;
            }
            if (this.fieldControl.hasError('required')) {
                this.customErrorMsg = this.label + ' is required';
                return true;
            }
            if (this.fieldControl.hasError(maxBytesError)) {
                this.customErrorMsg = 'Field exceeds maximum characters.';
                return true;
            }
            if (this.fieldControl.hasError('minlength') && !this.isInputFocused) {
                this.customErrorMsg = this.label + ' should have a minimum of ' + this.minValueLength + ' digits.';
                return true;
            }
            if (this.controlName === 'scheduledShipmentDate' && this.fieldControl.hasError('pattern')) {
                this.customErrorMsg = 'Please enter date in the format: DD-MMM-YYYY';
                return true;
            }
            if (this.fieldControl.hasError('pattern') || this.fieldControl.hasError(inValidDateError)) {
                this.customErrorMsg = 'Please enter valid ' + this.label;
                return true;
            }
        } else {
            this.customErrorMsg = '';
        }
        return false;
    }

    public handleChange(value: boolean) {
        this.onRadioButtonValueChanged.emit(value);
    }

    public onSearchBoxChange(searchText: string) {
        this.filterItems = this.dropDownList.filter(item => item.value.toLowerCase().indexOf(searchText.toLowerCase()) !== -1);
    }

    public displayDropdown() {
        this.showDropDown = !this.showDropDown;
        this.filterItems = this.dropDownList;
    }
}